<template>
  <ul class="mainmenu">
    <li>
      <router-link to="/">Home</router-link>
    </li>
    <li class="has-droupdown has-menu-child-item">
      <router-link :to="{ name: 'Product', params: { category: 'all' }, query: $route.query }">
        All Products
        <Icon name="plus" class="collapse-icon plus"/>
        <Icon name="minus" class="collapse-icon minus"/>
      </router-link>
      <ul class="submenu" v-if="categories.length">
        <li v-for="category of categories" :key="category.name">
          <router-link :to="{ name: 'Product', params: { category: category.name }, query: $route.query }">{{ category.name }}</router-link>
        </li>
      </ul>
    </li>
    <li class="has-droupdown has-menu-child-item">
      <a>
        Installation Tutorial
        <Icon name="plus" class="collapse-icon plus"/>
        <Icon name="minus" class="collapse-icon minus"/>
      </a>
      <ul class="submenu">
        <li>
          <router-link :to="`/installation/glassSwitch1`">Installation Instruction for Nintendo Switch 2017 / PS Portal</router-link>
        </li>
        <li>
          <router-link :to="`/installation/glassSwitch2`">Installation Instruction for Nintendo Switch OLED / Switch 2</router-link>
        </li>
        <li>
          <router-link :to="`/installation/glassSwitch2-Tray`">Installation Instruction with Application Tray for NS 2</router-link>
        </li>
        <li>
          <router-link :to="`/installation/caseSwitch2`">Installation Instruction for NS 2 Protective Case</router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import Icon from '../../icon/Icon'
import site from '@/data/site.json'

export default {
  name: 'Nav',
  components: { Icon },
  data() {
    return { categories: site.categories }
  }
}
</script>
